import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import ImageUploader from '../../components/admin/ImageUploader';

export default function AboutPageManager() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const defaultPart1 = 'KARE YAPI İNŞAAT, 15 yılı aşkın süredir Türkiye\'nin inşaat sektöründe kalite, güven ve mimari estetiği yeniden tanımlayan köklü bir A Sınıfı Müteahhitlik markasıdır. Kurulduğumuz ilk günden bu yana, sadece binalar değil; nesilden nesile güvenle aktarılacak devasa yaşam merkezleri, prestijli ticari alanlar ve mutlu aile yuvaları inşa ediyoruz.';
  const defaultPart2 = 'Her projemizde "İnsan Odaklı Gelişim" felsefesini kalbimize koyuyor, İstanbul\'un en değerli lokasyonlarında arazinin ruhuna uygun, doğayla barışık ve en ileri mühendislik teknolojilerini kullanan anıtsal yapılar yükseltiyoruz. Bizim için bir inşaat; beton ve demirden ibaret değil, uzun ömürlü bir sanat eseridir.';

  // Kurumsal Yazi Alanları
  const [title, setTitle] = useState('KARE YAPI: GELECEĞİ SAĞLAM TEMELLER ÜZERİNE İNŞA EDEN GÜÇ');
  const [storyPart1, setStoryPart1] = useState(defaultPart1);
  const [storyPart2, setStoryPart2] = useState(defaultPart2);
  const [companyImage, setCompanyImage] = useState('');

  // Sertifikalar (Sadece Başlık/İsim)
  const [certificates, setCertificates] = useState([
    { id: 1, name: 'ISO 9001:2015 Kalite Yönetimi', image: '' },
    { id: 2, name: 'ISO 14001:2015 Çevre Yönetimi', image: '' },
    { id: 3, name: 'OHSAS 18001 İş Sağlığı ve Güvenliği', image: '' },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, 'pages', 'about');
        const snap = await getDoc(docRef);
        
        let dataToSave: any = { title, storyPart1, storyPart2, companyImage, certificates };

        if (snap.exists() && snap.data().title) {
          const data = snap.data();
          if (data.title) setTitle(data.title);
          
          if (data.storyPart1 && data.storyPart1.includes('KARE YAPI İNŞAAT, sektördeki köklü geçmişi')) {
             setStoryPart1(defaultPart1);
             dataToSave.storyPart1 = defaultPart1;
          } else if (data.storyPart1) {
             setStoryPart1(data.storyPart1);
             dataToSave.storyPart1 = data.storyPart1;
          }

          if (data.storyPart2 && data.storyPart2.includes('Her projemizde "önce insan"')) {
             setStoryPart2(defaultPart2);
             dataToSave.storyPart2 = defaultPart2;
          } else if (data.storyPart2) {
             setStoryPart2(data.storyPart2);
             dataToSave.storyPart2 = data.storyPart2;
          }
          
          const defaultCompanyImg = data.companyImage || '/premium-project-block.png';
          setCompanyImage(defaultCompanyImg);
          
          let defaultCerts = certificates;
          if (data.certificates && data.certificates.length > 0) {
            defaultCerts = data.certificates;
          }
          setCertificates(defaultCerts);

          dataToSave = { ...data, storyPart1: dataToSave.storyPart1, storyPart2: dataToSave.storyPart2, companyImage: defaultCompanyImg, certificates: defaultCerts };
        } else {
          dataToSave.companyImage = '/premium-project-block.png';
          setCompanyImage(dataToSave.companyImage);
        }

        await setDoc(docRef, { ...dataToSave, updatedAt: new Date() }, { merge: true });
        
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      const docRef = doc(db, 'pages', 'about');
      await setDoc(docRef, { title, storyPart1, storyPart2, companyImage, certificates, updatedAt: new Date() }, { merge: true });
      setMessage('Kurumsal bilgiler başarıyla güncellendi!');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error(err);
      setMessage('Kayıt başarısız oldu.');
    } finally {
      setSaving(false);
    }
  };

  const updateCertificateName = (id: number, val: string) => {
    setCertificates(certificates.map(c => c.id === id ? { ...c, name: val } : c));
  };

  const updateCertificateImage = (id: number, val: string) => {
    setCertificates(certificates.map(c => c.id === id ? { ...c, image: val } : c));
  };

  if (loading) return <div className="text-zinc-500">Yükleniyor...</div>;

  return (
    <div className="space-y-6 pb-24">
      <div className="mb-6">
        <h2 className="text-2xl font-black text-white uppercase tracking-widest" style={{ fontFamily: 'Raleway, sans-serif' }}>Kurumsal Yönetimi</h2>
        <p className="text-zinc-400 text-sm mt-1">Hakkımızda sayfasındaki şirket hikayesini, misyon/vizyonu ve sertifika listesini düzenleyin.</p>
      </div>

      {message && (
        <div className={`p-4 rounded-xl font-bold text-sm ${message.includes('başarısız') ? 'bg-red-500/10 text-red-500' : 'bg-green-500/10 text-green-500'}`}>
          {message}
        </div>
      )}

      {/* ŞİRKET HİKAYESİ */}
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-8">
        <div className="flex items-center gap-3 mb-6 border-b border-zinc-800 pb-4">
          <i className="ri-building-line text-2xl text-red-500"></i>
          <h3 className="text-lg font-bold text-white uppercase tracking-wider">Şirket Hikayesi (Biz Kimiz?)</h3>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Sayfa Ana Başlığı</label>
            <input type="text" value={title} onChange={e => setTitle(e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Giriş Paragrafı (Kırmızı vurgulu bölüm)</label>
            <textarea value={storyPart1} onChange={e => setStoryPart1(e.target.value)} rows={4} className="w-full bg-zinc-950 border border-zinc-800 text-zinc-300 rounded-xl py-4 px-5 focus:border-red-500 focus:outline-none"></textarea>
          </div>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Detay Paragrafı</label>
            <textarea value={storyPart2} onChange={e => setStoryPart2(e.target.value)} rows={4} className="w-full bg-zinc-950 border border-zinc-800 text-zinc-300 rounded-xl py-4 px-5 focus:border-red-500 focus:outline-none"></textarea>
          </div>
          <div className="pt-2">
            <ImageUploader 
              currentImageUrl={companyImage} 
              onImageUploaded={(url) => setCompanyImage(url)} 
              onImageDeleted={() => setCompanyImage('')} 
              folderPath="pages/about/company"
              label="Kurumsal Tanıtım Görseli (Hikaye Yanı)"
            />
          </div>
        </div>
      </motion.div>

      {/* SERTİFİKALAR */}
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-8">
        <div className="flex items-center gap-3 mb-6 border-b border-zinc-800 pb-4">
          <i className="ri-award-line text-2xl text-red-500"></i>
          <h3 className="text-lg font-bold text-white uppercase tracking-wider">ISO ve Kalite Belgeleri Listesi</h3>
        </div>

        <div className="space-y-6">
          {certificates.map((cert) => (
             <div key={cert.id} className="flex flex-col md:flex-row gap-6 p-4 border border-zinc-800 rounded-xl bg-zinc-950">
               <div className="w-10 h-10 rounded-full bg-zinc-800 flex items-center justify-center text-zinc-400 font-bold shrink-0">{cert.id}</div>
               <div className="flex-1 space-y-4">
                 <div>
                   <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">Sertifika İsmi</label>
                   <input type="text" value={cert.name} onChange={e => updateCertificateName(cert.id, e.target.value)} className="w-full bg-zinc-900 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
                 </div>
                 <ImageUploader 
                   currentImageUrl={cert.image} 
                   onImageUploaded={(url) => updateCertificateImage(cert.id, url)} 
                   onImageDeleted={() => updateCertificateImage(cert.id, '')} 
                   folderPath={`pages/about/certificates_${cert.id}`}
                   label={`${cert.id}. Sertifika Görseli`}
                 />
               </div>
             </div>
          ))}
        </div>
      </motion.div>

      {/* DEV KAYDET BUTONU */}
      <div className="fixed bottom-0 left-0 right-0 md:left-64 bg-zinc-950/80 backdrop-blur-lg border-t border-zinc-800 p-4 flex justify-end z-50">
         <button onClick={handleSave} disabled={saving} className="bg-red-600 hover:bg-red-700 text-white font-black text-lg py-4 px-12 rounded-xl shadow-2xl shadow-red-600/30 transition-all flex items-center gap-3 disabled:opacity-50">
           {saving ? <i className="ri-loader-4-line animate-spin"></i> : <i className="ri-save-3-line"></i>}
           KURUMSAL İÇERİĞİ KAYDET
         </button>
      </div>
    </div>
  );
}
